const cdn = "https://cdn.robodk.com";

window.Paths = {
    HOST_DETAILS: !window.Settings.LOCAL_BUILD && window.location.hostname.includes("web.robodk.com") ? "//robodk.com" : "",

    FOLDER_ROBOTS_IMG: window.Settings.LOCAL_BUILD
        ? "Sources/Robots/files/"
        : "/robot/img/",
    FOLDER_ROBOTS_IMG_CDN: "/robot/img/",

    FOLDER_AXES_IMG: window.Settings.LOCAL_BUILD
        ? "Sources/Axes/files/"
        : "/robot/img/",
    FOLDER_AXES_IMG_CDN: "/robot/img/",

    FOLDER_MECHANISMS_IMG: window.Settings.LOCAL_BUILD
        ? "Sources/Mechanisms/files/"
        : "/robotlib/tools/",
    FOLDER_MECHANISMS_IMG_CDN: "/robotlib/tools/",

    FOLDER_TOOLS_IMG: window.Settings.LOCAL_BUILD
        ? "Sources/Tools/files/"
        : "/robotlib/tools/",
    FOLDER_TOOLS_IMG_CDN: "/robotlib/tools/",

    FOLDER_OBJECTS_IMG: window.Settings.LOCAL_BUILD
        ? "Sources/Objects/files/"
        : "/robotlib/tools/",
    FOLDER_OBJECTS_IMG_CDN: "/robotlib/tools/",

    FOLDER_STATIONS_IMG: window.Settings.LOCAL_BUILD
        ? "Sources/Stations/files/"
        : "/library-stations/lib/img/",
    FOLDER_STATIONS_IMG_CDN: "/library-stations/lib/img/",

    FOLDER_ADDINS_IMG: window.Settings.LOCAL_BUILD
        ? "Sources/Addins/files/"
        : "/library-addins/lib/",
    FOLDER_ADDINS_IMG_CDN: "/library-addins/lib/",

    ROBOT_LIB_ASSETS: "/library-robots/lib_assets/",
    STATION_LIB_ASSETS: "/library-stations/lib_assets/",
    ADDIN_LIB_ASSETS: "/library-addins/lib_assets/",
    POST_LIB_ASSETS: "/library-post/lib_assets/",
    DETAILS_LIB_ASSETS: "/library-details/lib_assets/",

    DOMAIN: (window.Settings.LOCAL_BUILD)
        ? ";domain=localhost"
        : ";domain=.robodk.com",
    DETAILS_URL: (window.Settings.LOCAL_BUILD)
        ? "http://localhost:3003/?"
        : "/library-details/item-details?",
    TRANSLATIONS: window.Settings.LOCAL_BUILD
        ? "RoboDK%20Web%20Library/src/i18n/translations/"
        : cdn + "/library-details/tr-",
    ROBODK_WEB_LINK: "/web",
    ROBODK_WEB_OPEN: "/web?-OpenURL=//robodk.com",
    ROBODK_WEB_EMBED: "/index-web.html?--Embedded&-OpenURL=//robodk.com", // I don't thjnk this is used
    ROBODK_CDN: cdn,
    ROBODK_WEB_OPEN_CDN: "/web?-OpenURL=" + cdn, 
    ROBODK_WEB_3D: "/3D/", 
    ROBODK_WEB_EMBED_CDN: "/index-web.html?--Embedded&-OpenURL=" + cdn,
    ROBODK_BUY: "https://robodk.com/buy",
    
    ROBOT_LIB_ASSETS_CDN: cdn + "/library-robots/lib_assets/",
    STATION_LIB_ASSETS_CDN: cdn + "/library-stations/lib_assets/",
    ADDIN_LIB_ASSETS_CDN: cdn + "/library-addins/lib_assets/",
    POST_LIB_ASSETS_CDN: cdn + "/library-post/lib_assets/",
    DETAILS_LIB_ASSETS_CDN: cdn + "/library-details/lib_assets/",

    ROBODK_SEARCH: "/search?libOnly=2&q="

    // Uncomment to test local with Web Design port 8000
    // ROBODK_SEARCH: "http://localhost:8000/search.php?q="
};
